<template>
  <div>
    <div class="owner_title">稿费预支及暂压稿</div>
    <div class="btn_box">
      <div class="search_box">
        <el-input
          placeholder="请输入内容"
          v-model="searchTxt"
          class="input-with-select"
        >
          <el-select
            v-model="select"
            slot="prepend"
            @change="changeSelect"
            placeholder="请选择"
          >
            <el-option label="写手昵称" value="1"></el-option>
            <el-option label="书名" value="2"></el-option>
          </el-select>
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="searchBtn"
          ></el-button>
        </el-input>
      </div>
      <div class="filtrate" @click="show_filter_form()">
        <i class="iconfont icon-shaixuan1"></i>
        <span>筛选</span>
      </div>
    </div>

    <!-- 筛选表单 -->
    <div class="task_filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="写手昵称" prop="writer_nickname">
          <el-input v-model="filter_form.writer_nickname"></el-input>
        </el-form-item>
        <el-form-item label="写手支付宝" prop="alipay_account">
          <el-input v-model="filter_form.alipay_account"></el-input>
        </el-form-item>
        <el-form-item label="写手姓名" prop="writer_name">
          <el-input v-model="filter_form.writer_name"></el-input>
        </el-form-item>
        <el-form-item label="书名" prop="connectionessay_name">
          <el-input v-model="filter_form.connectionessay_name"></el-input>
        </el-form-item>
        <el-form-item label="是否有任务">
          <el-select v-model="filter_form.is_task" placeholder="是否有任务">
            <el-option label="全部" value=""></el-option>
            <el-option label="无任务" value="0"></el-option>
            <el-option label="有任务" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日周结">
          <el-select v-model="filter_form.write_type" placeholder="日周结">
            <el-option label="全部" value=""></el-option>
            <el-option label="日结" value="1"></el-option>
            <el-option label="周结" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="filter_form.createtime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="goSearch"
          >搜索</el-button
        >
      </el-form>
    </div>

    <div class="task_box">
      <!-- 表格数据 -->
      <el-table ref="multipleTable" height="550" :data="dataShow" border>
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          prop="writer_nickname"
          align="center"
          label="写手昵称"
          sortable
          width="300"
        >
        </el-table-column>
        <el-table-column
          prop="alipay_account"
          align="center"
          label="写手支付宝"
          sortable
          width="200"
        >
        </el-table-column>
        <el-table-column
          prop="writer_name"
          align="center"
          label="写手姓名"
          sortable
          width="140"
        >
        </el-table-column>
        <el-table-column
          prop="connectionessay_name"
          align="center"
          label="书名"
          sortable
          width="300"
        >
        </el-table-column>
        <el-table-column
          prop="can_fee"
          align="center"
          label="可预支稿费"
          sortable
          width="150"
        >
        </el-table-column>

        <el-table-column
          prop="advance_fee"
          align="center"
          label="预支金额"
          sortable
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="surplus_fee"
          align="center"
          label="预支剩余稿费"
          sortable
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="over_deposit_money"
          align="center"
          label="暂压稿费"
          sortable
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="is_task"
          align="center"
          label="任务状态"
          sortable
          width="120"
        >
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.is_task == '0'
                  ? ''
                  : scope.row.is_task == '1'
                  ? 'info'
                  : scope.row.is_task == '2'
                  ? 'success'
                  : 'danger'
              "
            >
              {{
                scope.row.is_task == "0"
                  ? "未开始"
                  : scope.row.is_task == "1"
                  ? "进行中"
                  : scope.row.is_task == "2"
                  ? "已完结"
                  : "已停止"
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createtime"
          align="center"
          label="创建时间"
          sortable
          width="250"
        >
        </el-table-column>
        <el-table-column
          :fixed="equipmentType == 1 ? false : 'right'"
          label="操作"
          align="center"
          width="210"
        >
          <template slot-scope="scope">
            <div class="cost_btn_box">
              <div
                @click="applyForDialog(scope.row)"
                :class="[
                  {
                    cost_btn: scope.row.write_type == 2,
                    disabled_btn:
                      scope.row.write_type == 1 ||
                      scope.row.over_deposit_money != 0
                  }
                ]"
              >
                <i class="iconfont icon-apply"></i>
                <span>稿费申请</span>
              </div>
              <div
                @click="costDialog(scope.row)"
                :class="[
                  {
                    cost_btn: scope.row.write_type == 2,
                    disabled_btn: scope.row.write_type == 1
                  }
                ]"
              >
                <i class="iconfont icon-jinqian-yuan"></i>
                <span>暂压稿费</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 稿费申请弹窗 -->
      <el-dialog
        title="稿费申请"
        :visible.sync="ApplyForDialogVisible"
        :width="dialogWidth"
        center
      >
        <el-form
          :model="ApplyForForm"
          class="apply_dialog_form"
          label-position="right"
          label-width="120px"
          :rules="ApplyForFormRules"
        >
          <el-form-item label="选择日:" class="remark_dialog">
            <el-select
              v-model="timeList"
              multiple
              placeholder="请选择"
              @change="selectAdvanceFee"
            >
              <el-option
                v-for="item in advancefeeList"
                :key="item.id"
                :label="item.record_time"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="可申请金额:">
            <div>{{ allFee }}</div>
          </el-form-item>
          <el-form-item label="稿费申请金额:" class="remark_dialog" prop="fee">
            <el-input v-model="ApplyForForm.fee"></el-input>
          </el-form-item>

          <el-form-item label="备注:" class="remark_dialog">
            <el-input v-model="ApplyForForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            class="dialog_btn"
            round
            type="primary"
            @click="applyForDialogSubmit"
            >确认申请</el-button
          >
          <el-button
            class="dialog_btn"
            round
            @click="ApplyForDialogVisible = false"
            >取 消</el-button
          >
        </span>
      </el-dialog>

      <!-- 暂压稿费弹窗 -->
      <el-dialog
        title="暂压稿费"
        :visible.sync="costDialogVisible"
        :width="dialogWidth"
        center
      >
        <el-form
          :model="costForm"
          class="cost_form"
          label-position="right"
          label-width="80px"
          :rules="costFormRules"
        >
          <el-form-item label="选择周:" class="cost_item">
            <el-select
              v-model="costForm.connectionessay_id"
              placeholder="请选择"
              @change="selectFee"
            >
              <el-option
                v-for="item in costList"
                :key="item.id"
                :label="item.record_time"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="暂压金额:" class="cost_item">
            <div>{{ costForm.deposit_money }}</div>
          </el-form-item>
          <el-form-item label="备注:" prop="remark" class="cost_item">
            <el-input v-model="costForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            class="dialog_btn"
            round
            type="primary"
            v-on:click.once="costDialogSubmit"
            >确认选择</el-button
          >
          <el-button class="dialog_btn" round @click="costDialogVisible = false"
            >取 消</el-button
          >
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  fee_manage_list,
  advancefee_list,
  advancefee_subscribe,
  depositprocess_list,
  depositprocess_subscribe
} from "@/utils/writer";
export default {
  data() {
    return {
      writerId: "", //用户id
      menuscriptList: [], //稿费列表
      isFilterForm: true, //筛选表单
      dialogWidth: "30%", //弹窗宽度
      ApplyForDialogVisible: false, //稿费申请弹窗
      costDialogVisible: false, //暂压稿费弹窗
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      timeList: [], //稿费
      advancefeeList: [], //稿费下拉列表
      allFee: 0, //多选总稿费
      ApplyForForm: {
        connectionessay_id: "", //书籍id
        connectionrecord_json: "", //下拉选择的json
        fee: "", //金额
        write_type: "", //日周结类型
        remark: "", //备注
        writer_expand_id: "" //写手扩展id
      },
      applyForId: "", //当前选中的书籍id
      selectApply: [], //选中下拉列表的值
      ApplyForFormRules: {
        fee: { required: true, trigger: "blur", message: "金额不能为空" }
      },
      costData: [], ////暂压
      costList: [], //暂压的下拉列表
      selectCost: [], //下拉列表选中的值
      costForm: {
        connectionessay_id: "", //书籍id
        connectionrecord_json: "", //下拉选择的json
        deposit_money: "", //暂压金额
        remark: "",
        writer_expand_id: ""
      },
      costFormRules: {
        deposit_money: { pattern: /^[0-9|^\\.]/, message: "数值不能为负数" }
      },
      // 筛选
      filter_form: {
        writer_nickname: "", //写手昵称
        alipay_account: "", //写手支付宝
        writer_name: "", //写手姓名
        connectionessay_name: "", //书名
        is_task: "", //任务状态
        write_type: "", //日周结
        createtime: "" //创建时间
      },
      searchTxt: "", //搜索内容
      select: "", //搜索的筛选
      selectId: "", //筛选项的id
      writeType: "", //日周结类型
      select_time_data: "",
      time_filter: "", //时间筛选
      equipmentType: 0 //判断移动端还是pc端  0：pc  1：移动
    };
  },
  created() {
    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;
    if (this.$isMobile.isDeviceType()) {
      this.equipmentType = 1;
      this.dialogWidth = "95%";
    } else {
      this.equipmentType = 0;
      this.dialogWidth = "30%";
    }
    this.getMenuScriptList();
  },

  methods: {
    // 获取查重列表
    getMenuScriptList() {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        page: 1,
        page_index: 10
      };

      fee_manage_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.menuscriptList = res.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },

    // 搜索的筛选
    changeSelect(val) {
      var that = this;
      that.selectId = val;
    },
    // 搜索按钮
    searchBtn() {
      var that = this;
      var obj;
      if (that.selectId == 1) {
        //根据写手昵称
        obj = {
          departmentuser_id: that.writerId,
          writer_nickname: that.searchTxt, //写手昵称
          page: 1,
          page_index: 10
        };
      } else {
        obj = {
          departmentuser_id: that.writerId,
          connectionessay_name: that.searchTxt, //书名
          page: 1,
          page_index: 10
        };
      }

      fee_manage_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.menuscriptList = res.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 筛选
    goSearch() {
      var that = this;
      var date1, date2;
      that.select_time_data = that.filter_form.createtime;
      date1 = that.select_time_data[0];
      date2 = that.select_time_data[1];
      if (date1 == undefined && date2 == undefined) {
        that.time_filter = "";
      } else {
        that.time_filter = date1 + " - " + date2;
      }
      console.log("that.time_filter", that.time_filter);
      that.filter_form.createtime = that.time_filter;
      let obj = {
        departmentuser_id: that.writerId,
        page: 1,
        page_index: 10,
        ...that.filter_form
      };
      fee_manage_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.menuscriptList = res.data.data;
          that.calcPageData();
          that.filter_form.createtime = that.select_time_data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 稿费申请-下拉列表
    applyForDialog(val) {
      var that = this;
      that.timeList = [];
      that.ApplyForForm.remark = "";
      that.ApplyForForm.fee = "";
      if (val.write_type == 1 || val.over_deposit_money != 0) {
        return false;
      }
      that.ApplyForDialogVisible = true;
      that.applyForId = val.connectionessay_id;
      that.ApplyForForm.writer_expand_id = val.writer_expand_id;
      let obj = {
        departmentuser_id: that.writerId,
        connectionessay_id: val.connectionessay_id,
        writer_expand_id: val.writer_expand_id
      };

      advancefee_list(obj).then(res => {
        if (res.data.code == 1) {
          that.advancefeeList = res.data.data.list;
          that.writeType = res.data.data.write_type;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    //多选
    selectAdvanceFee(val) {
      var that = this;
      var selectIds = val;
      var fee = 0;
      var result = that.advancefeeList.filter(item =>
        selectIds.some(i => item.id == i)
      );

      that.selectApply = result;
      result.forEach(item => {
        fee += item.fee;
      });
      that.allFee = fee;
    },
    // 下拉日期选中
    selectDay() {
      var that = this;

      that.timeList = that.advancefeeList;
      if (that.advancefeeList) {
        var item = that.advancefeeList.find(
          i => i.id === that.ApplyForForm.connectionessay_id
        );
        that.advancefeeList = item;
      }
    },
    // 稿费申请-提交
    applyForDialogSubmit() {
      var that = this;
      var money;
      if (that.ApplyForForm.fee > that.allFee) {
        this.$message.error("输入金额超出范围！");
      } else {
        money = that.ApplyForForm.fee;
        // var connectionrecord_json = [];
        // that.advancefeeList.forEach(item => {
        //   connectionrecord_json.push(item);
        // });
        var json_data = JSON.stringify(that.selectApply);
        // var json_data = that.selectApply;
        let obj = {
          departmentuser_id: that.writerId,
          connectionessay_id: that.applyForId,
          writer_expand_id: that.ApplyForForm.writer_expand_id,
          connectionrecord_json: json_data,
          write_type: that.writeType,
          remark: that.ApplyForForm.remark,
          money: money
        };

        advancefee_subscribe(obj).then(res => {
          if (res.data.code == 1) {
            that.ApplyForDialogVisible = false;
            // that.getMenuScriptList();
            that.goSearch();
            this.$message.success(res.data.msg);
          } else {
            that.ApplyForDialogVisible = false;
            // that.getMenuScriptList();
            that.goSearch();
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    // 暂压稿费-下拉列表
    costDialog(val) {
      var that = this;
      if (val.write_type == 1) {
        return false;
      }
      that.costData = [];
      that.costForm = {};
      that.costDialogVisible = true;
      that.applyForId = val.connectionessay_id;
      that.costForm.writer_expand_id = val.writer_expand_id;
      let obj = {
        departmentuser_id: that.writerId,
        connectionessay_id: val.connectionessay_id,
        writer_expand_id: val.writer_expand_id
      };
      depositprocess_list(obj).then(res => {
        if (res.data.code == 1) {
          that.costList = res.data.data.list;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 选择暂压稿费
    selectFee() {
      var that = this;
      that.costData = that.costList;
      if (that.costData) {
        var item = that.costData.find(
          i => i.id === that.costForm.connectionessay_id
        );
        that.selectCost = item;
        that.costForm.deposit_money = item.fee;
      }
    },
    // 暂压稿费-提交
    costDialogSubmit() {
      var that = this;
      if (that.costForm.deposit_money < 0) {
        this.$message.error("数值不能为负数");
        return false;
      }

      var connectionrecord_json = [];
      // that.selectCost.forEach(item => {
      connectionrecord_json.push(that.selectCost);
      // });
      let obj = {
        departmentuser_id: that.writerId,
        connectionessay_id: that.applyForId,
        deposit_money: that.costForm.deposit_money,
        remark: that.costForm.remark,
        connectionrecord_json: JSON.stringify(connectionrecord_json),
        writer_expand_id: that.costForm.writer_expand_id
      };
      depositprocess_subscribe(obj).then(res => {
        if (res.data.code == 1) {
          that.costDialogVisible = false;
          // that.getMenuScriptList();
          that.goSearch();
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 计算页数的方法
    calcPageData() {
      if (this.menuscriptList.length > 1) {
        this.pageNum =
          Math.ceil(this.menuscriptList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.menuscriptList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}
.task_box {
  margin: 0px 15px;
}
.task_btn {
  width: 90px;
  height: 25px;
  text-align: center;
  line-height: 5px;
  background: #f3f8ff;
  color: #157df8;
}
.cost_btn_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}
.cost_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #e7f2ff;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  border-radius: 10px;
}
.cost_btn i {
  font-size: 12px;
}
.info_icon {
  font-size: 12px;
}
.btn_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 15px 15px 10px 15px;
}
.search_box {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}
.search_box .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.search_box .el-select {
  width: 130px;
}
.search_btn {
  font-size: 15px;
  padding: 8px;
  margin-left: 5px;
}
.addInfo,
.filtrate i {
  font-size: 14px;
}
.filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.task_filter_form {
  background: #ffffff;
  margin: 0px 15px;
  padding: 15px;
}
.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}

.cost_form {
  width: 400px;
}
.cost_form .el-form-item__label {
  width: 150px;
}
.cost_form .el-form-item {
  display: flex;
  flex-direction: row;
}
.cost_form .el-input__inner {
  width: 200px;
}

.table_box .el-button:focus,
.el-button:hover {
  color: #fff;
  border-color: #c6e2ff;
  background-color: #157df8;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.el-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 20px;
  border-radius: 10px;
  margin-left: 15px;
}
.disabled_btn {
  cursor: not-allowed;
  width: 90px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #eeeeee;
  color: #8893a7;
  border-radius: 10px;
  margin-right: 5px;
  font-size: 12px;
  /* pointer-events: none; */
}
.disabled_btn i {
  font-size: 12px;
}
.remark_dialog {
  display: flex;
  flex-direction: row;
}

.remark_dialog /deep/ .el-input {
  width: 220px;
  margin-left: -120px !important;
}
.cost_item /deep/ .el-input {
  width: 220px;
  margin-left: -80px !important;
}
.apply_dialog_form /deep/ .el-select {
  width: 220px !important;
}
.remark_dialog /deep/ .el-select__tags {
  margin-left: -110px;
}
.remark_dialog /deep/ .el-select .el-tag {
  width: 210px !important;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .search_box {
    width: 63%;
  }
  .search_box .el-select {
    width: 40px;
  }
  .cost_btn,
  .disabled_btn {
    width: 50px;
  }
  .task_box {
    margin-bottom: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/writer/ManuscriptManage.vue